var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5001 57.9001H63.6001V79.8801H79.5001V57.9001Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 45.1C95.1509 45.1 97.3 42.951 97.3 40.3C97.3 37.649 95.1509 35.5 92.5 35.5C89.849 35.5 87.7 37.649 87.7 40.3C87.7 42.951 89.849 45.1 92.5 45.1Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3242 96.9726L19.6658 99.7336L20.5253 104.608L36.1838 101.847L35.3242 96.9726Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1 65.3C44.751 65.3 46.9001 63.1509 46.9001 60.5C46.9001 57.849 44.751 55.7 42.1 55.7C39.4491 55.7 37.3 57.849 37.3 60.5C37.3 63.1509 39.4491 65.3 42.1 65.3Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1915 63.5189L88.3181 113.843L138.632 122.714L147.505 72.3905L97.1915 63.5189Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.9 84.1001L112.6 119.7L97 116.9L103.3 81.3001L113.1 71.6001L118.9 84.1001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.3 87.7001C134.951 87.7001 137.1 85.5511 137.1 82.9001C137.1 80.2491 134.951 78.1001 132.3 78.1001C129.649 78.1001 127.5 80.2491 127.5 82.9001C127.5 85.5511 129.649 87.7001 132.3 87.7001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4 78.4001H54.5V27.3H105.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79 48.2V57.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6001 48.2V57.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 55.6001H79.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 51.7H79.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7 48.2V57.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7 78.4001H79.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 27.3V60.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 79.0999V55.7H106.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106 83.2L105.4 86.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105 89.1001L104.4 92.3001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94.5L103.5 97.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.7 100.8L127 104.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.6 106.8L126.1 109.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.7 112.1L125.1 115.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 120.4L125.7 97.4001L143.3 100.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 103L11.4 104.6L2.5 54.3001L48.8 46.1001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 90.2L20 99.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3999 87.5L35.0999 97.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2 88.8L27.9 98.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 97.3L35.2999 94.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93.4L34.6 90.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8999 78.9001L44.5999 82.6001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84.9001L45.5 88.0001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8999 90.2L46.4999 93.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 83.6001L61.7 95.7001L36 100.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8999 99.4001L40.8999 76.3001L48.7999 74.9001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictures);
export default __webpack_public_path__ + "static/media/pictures.6745ba8b08df7399409fe5b11dd1ac29.svg";
export { ForwardRef as ReactComponent };